import { ChangeDetectionStrategy, Component, ElementRef, HostBinding, Input, OnDestroy, ViewChild } from '@angular/core';
import { PreviewMode } from '../../../model/preview-mode';
import { PreviewItemModel } from '../../file-preview.component';
import { BasePreviewComponent } from '../base-preview/base-preview.component';
import { Config } from '@environments/config';
import { ErrorType } from '@shared/services/stream-content.service';

@Component({
  selector: 'media-preview',
  templateUrl: './media-preview.component.html',
  styleUrls: ['./media-preview.component.scss', '../../../file-preview-shared.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediaPreviewComponent extends BasePreviewComponent implements OnDestroy {
  @ViewChild('mediaRef') mediaRef: ElementRef;
  allowControls: boolean;
  @HostBinding('style.display')
  get display() {
    if (!this.show) {
      return 'none';
    }
    return 'flex';
  }
  @HostBinding('style.cursor')
  get cursor(): string {
    return this.previewMode !== 'popup' ? 'pointer' : 'default';
  }

  @Input() set previewMode(val: PreviewMode) {
    this.isPopup = val === 'popup';
    this._previewMode = val;

    this.isPopup ? this.play() : this.stop();

    setTimeout(() => {
      this.allowControls = this.isPopup;
      this.cdr.markForCheck();
    }, 0);

    this.cdr.markForCheck();
  }

  get previewMode() {
    return this._previewMode;
  }

  @Input() set model(model: PreviewItemModel) {
    this._model = model;
    if (!this.modelValidated()) {
      return;
    }
    this.streamContentService
      .streamBlobSrc(model.item.srcUrl, Config.preview.files.maxSizeInMB)
      .then(async (url: string) => {
        this.srcUrl = url;
        this.finishLoad();
      })
      .catch((err: ErrorType) => {
        this.errorType = err;
        this.finishLoad();
      });
    this.cdr.markForCheck();
  }
  get model(): PreviewItemModel {
    return this._model;
  }

  set width(val: number) {
    this._width = val;
    this.scaleEl(this.mediaRef?.nativeElement, val);
  }

  get width() {
    return this._width;
  }

  @Input() set show(show: boolean) {
    this._show = show;
  }

  get show() {
    return this._show;
  }

  get isAudio() {
    return this.model.fileType === 'audio';
  }

  isPopup: boolean;
  srcUrl: string;

  ngOnDestroy() {
    if (this.mediaRef) {
      this.mediaRef.nativeElement.src = '';
    }
  }

  private stop() {
    const mediaRef = this.getMediaRef();
    if (!mediaRef) return;
    mediaRef.pause();
    mediaRef.currentTime = 0;
  }

  private play() {
    this.getMediaRef()?.play();
  }

  private getMediaRef() {
    return this.mediaRef?.nativeElement as HTMLVideoElement;
  }
}
